import {Component, Input, OnInit} from '@angular/core';
import {SimpleValueModel} from '../simple-value/simple-value.service';
import {IntlService} from '@progress/kendo-angular-intl';

@Component({
    selector: 'app-proj-rev-card',
    templateUrl: './proj-rev-card.component.html',
    styleUrls: ['./proj-rev-card.component.scss']
})
export class ProjRevCardComponent implements OnInit {
    @Input() dataKey: string;
    @Input() subType = 'val'; // 'val' or 'target'
    public isSubValuePositive = true;
    public subIcon = {
        class: '',
        style: {
            'vertical-align': '',
            verticalAlign: 0.2
        }
    };

    svModel: SimpleValueModel;
    hasAction: boolean;
    private pAction: string;

    get action(): string {
        return this.pAction;
    }

    @Input('action')
    set action(value: string) {
        this.pAction = value;
        this.hasAction = !!value;
    }

    @Input() set allValues(values: any) {
        this._loadAllValues(values);
    }

    constructor(private intl: IntlService) {
    }

    ngOnInit() {
    }

    _loadAllValues(arr: any) {
        if (arr && arr.hasOwnProperty(this.dataKey) && typeof (arr[this.dataKey].value) !== 'undefined') {
            const resp = arr[this.dataKey];
            const val = parseFloat(resp.value);
            let subVal;
            if (resp.sub === '-') {
                subVal = resp.sub;
            } else {
                subVal = parseFloat(resp.sub);
                this.isSubValuePositive = this.subType === 'val' ? (subVal >= 0) : (subVal < val);
            }
            const sub = this.intl.formatNumber(subVal, 'p2');
            const value = this.intl.formatNumber(val, 'c0');

            this.setSubIcon();
            this.svModel = {
                sub,
                value
            };
        }
    }

    private setSubIcon(): void {
        if (this.subType === 'target') {
            this.subIcon.class = 'far fa-dot-circle';
        } else {
            this.subIcon.class = `fas fa-sort-${this.isSubValuePositive ? 'up' : 'down'}`;
            this.subIcon.style['vertical-align'] = `${this.subIcon.style.verticalAlign * (this.isSubValuePositive ? -1 : 1)}em`;
        }
    }

}
